module.exports = __webpack_public_path__ + "img/download-app.28c4b179.png";